import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-69b3f210"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-heading" }
const _hoisted_2 = { class: "section-heading__eyebrow" }
const _hoisted_3 = {
  key: 0,
  class: "section-heading__description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.eyebrow), 1),
    _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1),
    (_ctx.description)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.description), 1))
      : _createCommentVNode("", true)
  ]))
}